// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"f4c45d2c","404":"d7eec461","498":"71d2491c","598":"00e4687b","787":"28cb0dcd"}[chunkId] + ".chunk.js";
};